import React from "react";
import { Clock3, User } from "lucide-react";
import { StatusBadge } from "../StatusBadge";

/** Minimal calendar card - deliberately shows only non-sensitive summary fields
 * (never résumé content or full applicant detail) per the interview calendar spec. */
export const BookingCard = ({ booking, compact = false, onClick }) => {
  const label = booking.applicant_name || booking.applicant_id?.slice(0, 8) || "Applicant";
  return (
    <button
      type="button"
      data-testid={`booking-card-${booking.id}`}
      onClick={onClick}
      className={`w-full text-left rounded-lg border border-gray-200 bg-gray-50 hover:border-blue-950 hover:bg-white transition-colors ${compact ? "p-1.5" : "p-3"}`}
    >
      <div className="flex items-center justify-between gap-1 mb-1">
        <span className="flex items-center gap-1 text-[11px] font-bold text-blue-950">
          <Clock3 size={11} /> {booking.start_time || "-"}
        </span>
        <StatusBadge status={booking.status} />
      </div>
      <p className="text-xs text-gray-600 truncate flex items-center gap-1"><User size={11} className="shrink-0" /> {label}</p>
      {!compact && booking.interviewer_name && (
        <p className="text-[11px] text-gray-500 mt-0.5">Interviewer: {booking.interviewer_name}</p>
      )}
    </button>
  );
};
